import { render, staticRenderFns } from "./VlFadeAnimation.vue?vue&type=template&id=c8284b0e&"
import script from "./VlFadeAnimation.vue?vue&type=script&lang=js&"
export * from "./VlFadeAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports